module.exports = __webpack_public_path__ + "static/img/empty.1d2ca11e.png";